import { render } from "./App.vue?vue&type=template&id=68a74fe4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=68a74fe4&lang=css"

import exportComponent from "/Volumes/DOCK_SSD/workspace/vscode/learnbody-diary-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__